import { Component, Input, OnInit } from '@angular/core';
import { AlertService, IAlertType, ConditionStoreService } from '../../../_shared/services';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ClrCommonFormsModule, ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from '@clr/angular';
import { RouterLink } from "@angular/router";
import { NgIf } from "@angular/common";
import {
  ClarityIcons,
  floppyIcon,
  pencilIcon,
  timesIcon,
  twoWayArrowsIcon,
  infoCircleIcon,
  checkCircleIcon
} from "@cds/core/icon";
import { EditConditionComponent } from "./edit-condition/edit-condition.component";
import { Conditions, WebserviceResponse } from "../../../_shared/interfaces";

@Component({
  selector: 'app-conditions',
  standalone: true,
  imports: [
    RouterLink,
    ClrIconModule,
    ClrCommonFormsModule,
    ReactiveFormsModule,
    ClrDatagridModule,
    NgIf,
    EditConditionComponent
  ],
  templateUrl: './conditions.component.html',
  styleUrl: './conditions.component.sass'
})

export class ConditionsComponent implements OnInit {
  public conditionsPaymentForm!: FormGroup;
  public conditionsDeliveryForm!: FormGroup;
  payment_conditions: any[] = [];
  delivery_conditions: any[] = [];
  conditionID: number = 0;
  descSort: ClrDatagridSortOrder = ClrDatagridSortOrder.ASC;
  loading: boolean = true;
  public updatePaymentIndex: number = 999;
  public updateDeliveryIndex: number = 999;

  @Input() editPayment: number = 0;  // 0 = Anzeige; 1 = Änderungsmodus, 2 = Position ändern
  @Input() editDelivery: number = 0;  // 0 = Anzeige; 1 = Änderungsmodus, 2 = Position ändern
  @Input() editPaymentNumber: number = 0;
  @Input() editDeliveryNumber: number = 0;
  @Input() editPaymentType: number = 0;
  @Input() editDeliveryType: number = 0;
  @Input() updatingPayment: boolean = false;
  @Input() updatingDelivery: boolean = false;

  get editpayment(): number {
    return this.editPayment;
  }
  set editpayment(value: number) {
    this.editPayment = value;
  }
  get editdelivery(): number {
    return this.editDelivery;
  }
  set editdelivery(value: number) {
    this.editDelivery = value;
  }
  constructor(
    private condss: ConditionStoreService,
    private alertDispatcher: AlertService,
    private fb: FormBuilder
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon, pencilIcon, floppyIcon, timesIcon, infoCircleIcon, checkCircleIcon);
    this.conditionsPaymentForm = this.fb.group({});
    this.conditionsDeliveryForm = this.fb.group({});
  }
  ngOnInit() {
    this.loading = true;
    this.editPayment = 0;
    this.editDelivery = 0;
    this.updatingPayment = false;
    this.updatingDelivery = false;
    this.loadPaymentList();
    this.loadDeliveryList();
    this.initPaymentForm();
    this.initDeliveryForm();
  }
  initPaymentForm() {
    this.conditionsPaymentForm = this.fb.group({
      cond_id: [this.conditionID],
      cond_type: [2], //2
      name: [''],
      text: [''],
      payment_term: [0],
      discount: [0],
      option: [false],
    });
  }
  initDeliveryForm() {
    this.conditionsDeliveryForm = this.fb.group({
      cond_id: [this.conditionID],
      cond_type: [1], //1
      name: [''],
      text: [''],
      payment_term: [0],
      discount: [0],
      option: [false],
    });
  }

  loadPaymentList() {
    this.condss.getConditionByType(2).subscribe({
      next: paymentConditionsData => {
        if (!paymentConditionsData || !paymentConditionsData.object || paymentConditionsData.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Zahlungsbedingungen gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          this.loading = false;
          return;
        }
        this.payment_conditions = Object.values(paymentConditionsData.object ?? {});
        console.table(this.payment_conditions);
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {}
    });
  }

  loadDeliveryList() {
    this.condss.getConditionByType(1).subscribe({
      next: deliveryConditionsData => {
        if (!deliveryConditionsData || !deliveryConditionsData.object || deliveryConditionsData.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Lieferbedingungen gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          this.loading = false;
          return;
        }
      this.delivery_conditions = Object.values(deliveryConditionsData.object ?? {});
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {}
    });
  }

  private normalizeConditionPayload(payload: any) {
    return {
      ...payload,
      cond_id: Number(payload?.cond_id ?? 0),
      cond_type: Number(payload?.cond_type ?? 0),
      payment_term: Number(payload?.payment_term ?? 0),
      discount: Number(payload?.discount ?? 0),
    };
  }

  addPayment() {
    const payload = this.normalizeConditionPayload(this.conditionsPaymentForm.value);
    this.condss.addCondition(payload)
      .subscribe((data: any) => {
        if (data?.hasErrors === false) {
          // this.editpos = 0;
          this.loadPaymentList();
          this.initPaymentForm();
        } else {
          return;
        }
      });
  }

  addDelivery() {
    const payload = this.normalizeConditionPayload(this.conditionsDeliveryForm.value);
    this.condss.addCondition(payload)
      .subscribe((data: any) => {
        if (data?.hasErrors === false) {
          this.loadDeliveryList();
          this.initDeliveryForm();
        } else {
          return;
        }
      });
  }

  updatePaymentMode(index: number, condition: number) {
    this.updatePaymentIndex = index;
    this.editPayment = 2;
    this.editPaymentNumber = condition;
    this.editPaymentType = 2;
    this.updatingPayment = true;
  }

  onUpdatePayment(_done: boolean) {
    this.editPayment = 1;
    this.updatingPayment = false;
    this.updatePaymentIndex = 999;
    this.loadPaymentList();
  }

  updateDeliveryMode(index: number, condition: number) {
    this.updateDeliveryIndex = index;
    this.editDelivery = 2;
    this.editDeliveryNumber = condition;
    this.editDeliveryType = 1;
    this.updatingDelivery = true;
  }

  onUpdateDelivery(_done: boolean) {
    this.editDelivery = 1;
    this.updatingDelivery = false;
    this.updateDeliveryIndex = 999;
    this.loadDeliveryList();
  }

  deletePayment(condition: number, name: string) {
    if (confirm('Zahlungsbedingung "' + name + '" wirklich löschen?')) {
      this.condss.deleteCondition(condition)
        .subscribe((data: any) => {
          this.loadPaymentList();
          if (data?.hasErrors === false) {
          } else {
            return;
          }
        });
    }
  }

  deleteDelivery(condition: number, name: string) {
    if (confirm('Lieferbedingung "' + name + '" wirklich löschen?')) {
      this.condss.deleteCondition(condition)
        .subscribe((data: any) => {
          this.loadDeliveryList();
          if (data?.hasErrors === false) {
          } else {
            return;
          }
        });
    }
  }
}
